module.exports = "\n<div class=\"card card-login\">\n  <div class=\"card-header text-center\" data-background-color=\"red\">\n    <h4 class=\"card-title\">Активация учётной записи</h4>\n  </div>\n  <div class=\"alert alert-primary error-info text-center\" [hidden]=\"!_activationError\">{{_activationError}}</div>\n  <new-password-form #newPassword (onSubitPasswordClick)=\"activateUser($event)\"></new-password-form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/account/activate/activate.component.html
// module id = ../../../../../src/app/account/activate/activate.component.html
// module chunks = 0